export const legalClientTypes = [
  { idLegalClientType: 1, LegalClientType: 'Natürliche Person' } as const,
  { idLegalClientType: 2, LegalClientType: 'Juristische Person' } as const,
];

export type ILegalClientType = (typeof legalClientTypes)[number];
